<template>
  <!-- A stored "iconoir:<name>" value as an svg. The icon set is split by first letter (src/icons/iconoir/<letter>.js)
       and a shard is fetched only when a page draws an icon starting with that letter; the server renders the svg
       (renderToString waits for async components) so there is no empty flash. The slot is the fallback. -->
  <component :is="shard" v-if="shard" :name="name"><slot></slot></component>
  <slot v-else></slot>
</template>

<script>
import {defineAsyncComponent, h} from "vue";
import IconoirGlyph from "./IconoirGlyph.vue";

const loaders = import.meta.glob("../icons/iconoir/*.js");
const shards = {};
// One async component per letter, made once and shared by every icon on the page.
function shardFor(letter) {
  const load = loaders[`../icons/iconoir/${letter}.js`];
  if (!load) return null;
  return (shards[letter] ||= defineAsyncComponent(async () => {
    const map = (await load()).default;
    return {props: {name: {type: String, default: ""}}, setup: (p, {slots}) => () => h(IconoirGlyph, {name: p.name, map}, slots)};
  }));
}
</script>

<script setup>
import {computed} from "vue";
import {iconoirName} from "@/utils/sectionLogic.js";

const props = defineProps({icon: {type: String, default: ""}});
const name = computed(() => iconoirName(props.icon));
const shard = computed(() => (name.value ? shardFor(name.value[0]) : null));
</script>
